var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgShield(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M15.7 4.137a.399.399 0 01.6 0c.037.043 2.597 3.057 8.309 3.057.216 0 .391.18.391.4v7.636c0 4.175-1.835 8.141-4.91 10.612-1.239.996-2.577 1.716-3.978 2.141a.38.38 0 01-.224 0c-1.4-.425-2.74-1.145-3.979-2.141C8.835 23.372 7 19.405 7 15.23V7.594c0-.221.175-.4.391-.4 5.75 0 8.283-3.027 8.308-3.057zm.3.834c-.835.82-3.427 2.91-8.217 3.019v7.24c0 3.931 1.723 7.664 4.61 9.983 1.128.907 2.341 1.569 3.607 1.97 1.266-.401 2.479-1.063 3.607-1.97 2.887-2.32 4.61-6.052 4.61-9.982V7.99c-4.79-.11-7.382-2.2-8.217-3.02zm-.22 2.256a.382.382 0 01.44 0c1.175.819 3.184 1.874 6.07 2.251a.398.398 0 01.342.397v5.378c0 3.44-1.496 6.697-4 8.713a9.844 9.844 0 01-2.49 1.48.381.381 0 01-.284 0 9.838 9.838 0 01-2.49-1.48c-2.504-2.016-4-5.274-4-8.713V9.875c0-.201.146-.371.341-.397 2.887-.377 4.896-1.432 6.072-2.25zm.22.81c-1.219.809-3.16 1.778-5.851 2.186v5.029c0 3.196 1.384 6.219 3.702 8.085.685.552 1.407.99 2.149 1.305a9.132 9.132 0 002.15-1.305c2.318-1.866 3.701-4.888 3.701-8.085v-5.03C19.161 9.816 17.22 8.847 16 8.038zm4.372 4.47a.378.378 0 01.548-.039.414.414 0 01.036.57l-5.434 6.456a.382.382 0 01-.279.138h-.013a.38.38 0 01-.274-.119l-3.105-3.228a.414.414 0 010-.57.377.377 0 01.549 0l2.811 2.923z"
  }));
}

export default SvgShield;